module.exports = __webpack_public_path__ + "static/media/sendWhite.e8e4590d.svg";